import { instance } from '@/api/instances'
import { addMixedDataLog } from '@/components/pillars/utils/addLog'
import { flattenHealthLogics } from '@/utils/healthLogicsMapper'

const fetchHealthLogicsByPersonId = async (store, personId) => {
  try {
    const healthLogics = await instance.get(`persons/${personId}/health_logics`)

    if (store.rootState.pillars.personId === personId) {
      store.commit('setHealthLogics', healthLogics)
    } else {
      addMixedDataLog('fetchHealthLogicsByPersonId')
    }
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'healthLogics/fetchHealthLogicsByPersonId' },
      { root: true }
    )
  }
}

const updatePersonHealthLogics = async (
  store,
  { personId, healthLogic, type }
) => {
  const endpoint = {
    new: `persons/${personId}/health_logics`,
    existing: `persons/${personId}/health_logics/edit`
  }[type]

  // No try/catch because failing to create/update will be handled by the component.
  const res = await instance.post(endpoint, {
    json: healthLogic
  })

  try {
    await res
    // Always fetch when creating/editing for the sake of consistency
    // because creation of logics that have been cancelled in the past
    // will update the already existing entity.
    await fetchHealthLogicsByPersonId(store, personId)
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'healthLogics/updatePersonHealthLogics' },
      { root: true }
    )
  }
}

const queryHealthLogics = async (_, { query }) => {
  try {
    const results = await instance.get('health_logics', {
      params: { query }
    })

    if (!results.length) throw new Error('Programs not found')

    return flattenHealthLogics(results)
  } catch (error) {
    return [
      {
        name: 'Não foram encontrados programas referentes a essa busca',
        programId: null,
        healthLogicId: null
      }
    ]
  }
}

const getProgramsByHealthLogicId = async (_, id) => {
  try {
    const response = await instance.get(`health_logics/${id}`)

    if (!response) {
      throw new Error('No health logic.')
    }

    return response.categories
  } catch (error) {
    return []
  }
}

export default {
  fetchHealthLogicsByPersonId,
  updatePersonHealthLogics,
  queryHealthLogics,
  getProgramsByHealthLogicId
}
